import { render } from "./DirectorFacultyCourseLoad.vue?vue&type=template&id=48ca2e51"
import script from "./DirectorFacultyCourseLoad.vue?vue&type=script&lang=js"
export * from "./DirectorFacultyCourseLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__